import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

export const getSeaSonByNameAndYear = (availSeasons, name, year) => {
  const curYearSeasons = availSeasons.find((item) => item.year === Number(year));
  if (curYearSeasons) {
    return curYearSeasons.ranges.find((item) => item.name === name);
  }
  return null;
};

export const getWeekRanges = (week) => {
  // 通过传入的时间段获取每周的区间 显示为字符串 例如2025/09/26-2025/10/02 返回2025/09/26-2025/10/02,2025/10/03-2025/10/09
  const weekRanges = [];
  let startDate = dayjs(week[0]);
  const endDate = dayjs(week[1]);

  while (startDate.isBefore(endDate) || startDate.isSame(endDate, "day")) {
    // 计算本周的结束日期
    let weekEnd = startDate.add(6, "day"); // 一周是7天，所以加6天

    // 如果本周的结束日期超出了指定的结束时间，则使用指定的结束时间
    if (weekEnd.isAfter(endDate)) {
      weekEnd = endDate;
    }

    weekRanges.push(startDate.format("YYYY/MM/DD") + "-" + weekEnd.format("YYYY/MM/DD"));

    // 如果本周的结束日期已经达到或超过指定的结束时间，则退出循环
    if (weekEnd.isSame(endDate, "day") || weekEnd.isAfter(endDate)) {
      break;
    }

    startDate = startDate.add(1, "week"); // 正确更新 startDate
  }

  return weekRanges;
};

// 根据传入的周数组，按照每个周去filter数据
export const getMovieListForWeek = (week, movieList) => {
  const weekRanges = getWeekRanges(week);
  return movieList.filter((item) => {
    return weekRanges.includes(item.openDate);
  });
};

// 判断某个日期属于哪一周
export const getWeekForDate = (date, weekRanges) => {
  const targetDate = dayjs(date);

  for (let i = 0; i < weekRanges.length; i++) {
    const weekRange = weekRanges[i];
    const [startDateStr, endDateStr] = weekRange.split("-");
    const startDate = dayjs(startDateStr);
    const endDate = dayjs(endDateStr);

    // 判断日期是否在这个周范围内（包含开始和结束日期）
    if (targetDate.isSameOrAfter(startDate, "day") && targetDate.isSameOrBefore(endDate, "day")) {
      return {
        weekIndex: i,
        weekRange: weekRange,
        startDate: startDateStr,
        endDate: endDateStr,
      };
    }
  }

  return null; // 如果日期不在任何一周内
};

// 获取日期所属周的索引（简化版本）
export const getWeekIndex = (date, weekRanges) => {
  const result = getWeekForDate(date, weekRanges);
  return result ? result.weekIndex : -1;
};

// 获取周范围显示文字
export const getWeekRangeText = (weekRanges) => {
  console.log("weekRanges", weekRanges);
  const [startDate, endDate] = weekRanges.split("-");
  return {
    start: {
      year: dayjs(startDate).format("YYYY"),
      month: dayjs(startDate).format("MM"),
      day: dayjs(startDate).format("DD"),
    },
    end: {
      year: dayjs(endDate).format("YYYY"),
      month: dayjs(endDate).format("MM"),
      day: dayjs(endDate).format("DD"),
    },
  };
};

/**
 * 以公开日为原点，计算查询区间相对公开日的天数偏移（非负，取相差天数）。
 * 例：openDate=2026-05-01, range=2026-07-01~2026-07-14
 * → dayOffsetFrom=61, dayOffsetTo=74
 */
export const calcDayOffsetsFromOpenDate = (openDate, rangeStart, rangeEnd) => {
  const open = dayjs(openDate).startOf("day");
  const from = dayjs(rangeStart).startOf("day");
  const to = dayjs(rangeEnd).startOf("day");
  if (!open.isValid() || !from.isValid() || !to.isValid()) {
    return null;
  }
  return {
    dayOffsetFrom: Math.abs(from.diff(open, "day")),
    dayOffsetTo: Math.abs(to.diff(open, "day")),
  };
};
